import { createFileRoute } from '@tanstack/react-router'
import DashboardPage from '../pages/DashboardPage/DashboardPage'
import { DashboardLoader } from '../components/loaders'

export const Route = createFileRoute('/dashboard')({
  component: DashboardPage,
  pendingComponent: DashboardLoader,
})
